import { CalendarHeartIcon } from './CalendarHeartIcon';

/**
 * author: Austin Andrews
 * id EF6AC5FE-7E6E-47AC-B5D8-E802CBB94E3B
 * name calendar-heart
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-heart.svg
 * tags
 * - Date / Time 
 */
export const EventHeartIcon = CalendarHeartIcon;
export default EventHeartIcon